import layout from '@views/layout/index.vue';

const walkthroughRoutes = [
  {
    path: '/gp',
    name: 'nav',
    component: layout,
    children: [
      {
        path: 'map/:id?',
        name: 'map',
        meta: {
          pageType: 'map',
          pageName: '地图库',
          keepAlive: false,
        },
        component: () => import(/* webpackChunkName: "map" */ '@views/tools/map/index.vue'),
      },
      {
        path: 'searchnew/:form', // 搜索新
        meta: {
          pageType: 'searchnew',
          pageName: '搜索新',
          keepAlive: false,
        },
        name: 'searchnew', // 搜索新
        component: () => import(
          /* webpackChunkName: "searchnew-index" */
          '@views/common/search/index/index.vue'),
      },
      {
        path: 'searchnew/:form/:keyword/', // 搜索结果新
        meta: {
          pageType: 'searchnew-result',
          pageName: '搜索结果新',
        },
        name: 'searchnew-result', // 搜索结果新
        component: () => import(
          /* webpackChunkName: "searchnew-result" */
          '@views/common/search/result/index.vue'),
      },
      {
        path: 'sensitivity',
        meta: {
          pageType: 'sensitivity',
          pageName: '大神灵敏度',
          keepAlive: true,
        },
        name: 'sensitivity', // 灵敏度设置
        component: () => import(
          /* webpackChunkName: "sensitivity" */
          '@views/tools/sensitivity/index.vue'),
      },
      {
        path: 'mapping',
        meta: {
          pageType: 'mapping',
          pageName: '键位布局',
          keepAlive: true,
        },
        name: 'mapping', // 键位设置
        component: () => import(
          /* webpackChunkName: "mapping" */
          '@views/tools/key-mapping/index/index.vue'),
      },
      {
        path: 'glequipment/:glequipmentType?',
        name: 'glequipment',
        meta: {
          pageType: 'glequipment',
          pageName: '武器库',
          keepAlive: true,
        },
        component: () => import(
          /* webpackChunkName: "glequipment" */
          '@views/tools/glequipment/index/index.vue'),
      },
      {
        path: 'music',
        name: 'music-index',
        meta: {
          pageType: 'music',
          pageName: '音乐',
          keepAlive: true,
        },
        component: () => import(
          /* webpackChunkName: "music" */
          '@views/tools/music/index.vue'),
      },
      {
        path: 'boutique',
        name: 'music-boutique',
        meta: {
          pageType: 'music',
          pageName: '精品',
          keepAlive: true,
        },
        component: () => import(
          /* webpackChunkName: "boutique" */
          '@views/tools/music/boutique/index.vue'),
      },
      {
        path: 'videozone',
        name: 'video-zone',
        meta: {
          pageType: 'music',
          pageName: '视频专区',
          keepAlive: true,
        },
        component: () => import(
          /* webpackChunkName: "videozone" */
          '@views/tools/music/zone/index.vue'),
      },
    ],
  },
  {
    path: '/gp/carsInfo/:carsType',
    name: 'carsInfo',
    meta: {
      pageType: 'carsInfo',
      pageName: '载具详情页',
      keepAlive: true,
    },
    component: () => import(
      /* webpackChunkName: "carsInfo" */
      '@views/tools/glequipment/carsInfo/index.vue'),
  },
  {
    path: '/gp/partsInfo/:partsType',
    name: 'partsInfo',
    meta: {
      pageType: 'partsInfo',
      pageName: '配件详情页',
      keepAlive: true,
    },
    component: () => import(
      /* webpackChunkName: "partsInfo" */
      '@views/tools/glequipment/partsInfo/index.vue'),
  },
  {
    path: '/gp/suppliesInfo/:suppliesType',
    name: 'suppliesInfo',
    meta: {
      pageType: 'suppliesInfo',
      pageName: '物资详情页',
      keepAlive: true,
    },
    component: () => import(
      /* webpackChunkName: "suppliesInfo" */
      '@views/tools/glequipment/suppliesInfo/index.vue'),
  },
  {
    path: '/gp/equipmentInfo/:id',
    name: 'equipmentInfo',
    meta: {
      pageType: 'equipmentInfo',
      pageName: '武器详情页',
      keepAlive: true,
    },
    component: () => import(
      /* webpackChunkName: "equipmentInfo" */
      '@views/tools/glequipment/equipmentInfo/index.vue'),
  },
  {
    path: '/gp/contrast/:eqType',
    name: 'contrast',
    meta: {
      pageType: 'contrast',
      pageName: '武器对比页',
      keepAlive: true,
    },
    component: () => import(
      /* webpackChunkName: "contrast" */
      '@views/tools/glequipment/contrast/index.vue'),
  },
  {
    path: '/gp/mapping-details',
    meta: {
      pageType: 'keymap',
      pageName: '键位布局详情',
      keepAlive: true,
    },
    name: 'mapping-details', // 键位设置
    component: () => import(
      /* webpackChunkName: "mapping" */
      '@views/tools/key-mapping/details/index.vue'),
  },
];

function addMeta(walkthroughRoute) {
  walkthroughRoute.children.forEach((route) => {
    if (route.children) {
      addMeta(route);
      return;
    }
    route.meta && (route.meta.sideBar = 'tools');
  });
}
addMeta(walkthroughRoutes[0]);
export default walkthroughRoutes;
